export default {
  viewBase: {
    'latestresults': '最新結果',
    'heartratetrend': '心率趨勢(月)',
    'HealthStatistics': '健康統計(月)',
    'nodata': '暫無數據',
    'poor': '不佳',
    'attention': '注意',
    'good': '良好',
    'averageheartrate': '平均心率',
    'heartratehealthy': '心率健康',
    'pressureindex': '壓力指數',
    'fatigueindex': '疲勞指數',
    'yes': '尚可',
    'normal': '正常',
    'overworked': '過勞',
    'relaxed': '輕鬆',
    'male': '男',
    'female': '女',
    'unknown': '未知',
    'myfamily': '我的家人',
    'Delete': '刪除',
    'prompt': '提示',
    'promptcurrent': '確認要解除當前家人關係？ ',
    'promptaccount': '您的家人是否有蓋德系統賬號？ ',
    'promptsystem': '如果您的家人使用手機號註冊過蓋德健康應用系統，您可以直接綁定手機賬號。無論您身在何處，都能隨時關注、管理家人健康。 ',
    'promptrelationship': '選擇家人關係',
    'mobilenumber': '手機號碼',
    'promptmobile': '請輸入手機號碼',
    'relationship': '家人關係',
    'bindnow': '立即綁定',
    'promptrelationshipnot': '家人關係未選擇',
    'promptmobilenot': '手機號格式錯誤',
    'bindsuc': '綁定成功',
    'save': '保存',
    'name': '姓名',
    'entername': '請輸入姓名',
    'head': '頭像',
    'gender': '性別',
    'promptgender': '選擇性別',
    'dateofbirth': '生日',
    'select': '請選擇',
    'detailedaddress': '詳細地址',
    'promptaddress': '請輸入詳細地址',
    'promptnamenot': '姓名未填寫',
    'promptgendernot': '性別未選擇',
    'promptdate': '出生日期未選擇',
    'addedsuc': '添加成功',
    'nomore': '沒有更多了',
    'high': '偏高',
    'low': '偏低',
    'oxygen': '血氧飽和度(%)',
    'flowvelocity': '血流速度',
    'loading': '加載中...',
    'goodtwo': '好',
    'viewECG': '查看心電圖',
    'next': '下一步',
    'ECGpicturenot': '心電圖圖片獲取失敗',
    'averageheartbeat': '平均心跳',
    'promptfat': '控制三高（高血脂、高血壓、高血糖），保持良好習慣並控制體重，有助於維持血管的健康減少心臟多餘的做工。 ',
    'promptpressure': '當處於壓力或緊張的狀況下，心率會加快，也能引起不規律的現象，建議維持心情的平和，找到適當的舒壓方法有助於維持健康。 ',
    'promptchronic': '可以同時參考慢性疲勞指數，如果慢性疲勞指數是呈現黃燈或紅燈，代表壓力是長時間累計的，就必須注意。 ',
    'promptfeel': '避免長時間的熬夜以及過於勞累，適當的休息。如果身體長時間不適，休息也無法改善的話，建議要即使去醫院就診。 ',
    'height': '身高（cm）',
    'weight': '體重（kg）',
    'promptweight': '請輸入體重',
    'promptheight': '請輸入身高',
    'uploading': '上傳中...',
    'promptcorrectheight': '請填寫正確的身高',
    'promptcorrectweight': '請填寫正確的體重',
    'promptcorrectbirthday': '請填寫正確的生日信息',
    'editsuc': '編輯成功',
    'promptcall': '確認要撥打電話嗎？ ',
    'logout': '退出登錄',
    'contactus': '聯繫我們',
    'privacypolicy': '隱私政策',
    'helpcenter': '幫助中心',
    'instructions': '使用說明',
    'basicinformation': '基本信息',
    'mobilelogin': '手機登錄',
    'promptmobilelogin': '請輸入手機號',
    'promptcode': '請輸入驗證碼',
    'login': '登錄',
    'checkok': '我已認真閱讀、理解並同意',
    'promptuser': '《用戶服務協議及隱私政策條款》',
    'putcode': '發送驗證碼',
    'promptcodenote': '驗證碼格式錯誤',
    'placepassword': '請輸入密碼',
    'noaccountnumber': '還沒有賬號',
    'immediateregistration': '立即註冊',
    'passwordfromerror': '密碼格式不正確',
    'passwordfromerrorsure': '兩次輸入密碼不一致',
    'placepasswordsix': '請輸入至少6位密碼',
    'surepassword': '確認密碼',
    'password': '密碼',
    'adressandcounty': '國家和地區',
    'phoneadress': '手機號歸屬地',
    'china': '中國',
    'phoneformaterror': '手機號格式錯誤',
    'codeformaterror': '驗證碼格式錯誤',
    'pleasephone': '請輸入手機號碼',
    'getwechatnot': '獲取微信信息失敗',
    'sendTo': '已發送至手機',
    'codeInfo': '驗證碼為 4 位數字',
    promptuserpla: '請同意《用戶服務協議及隱私政策條款》'

  }
}
